import styled from 'styled-components';

export const Container = styled.div<{ cover: string }>`
  border-radius: 15px;
  min-height: 600px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-start;
  padding: 15px 15px 25px;
  background: linear-gradient(0deg, rgba(0, 0, 0, 1), rgba(0, 0, 0, 0)),
  url(${({ cover }) => cover}) no-repeat center center / cover;
  gap: 12px;
`;

export const HotelLogo = styled.img`
  height: 80px;
  width: 80px;
  border-radius: 15px;
  overflow: hidden;
  object-fit: cover;
  box-sizing: border-box;
`;

export const Title = styled.span`
  color: #ffffff;
  font-size: 24px;
  line-height: 32px;
  font-weight: 400;
`;

export const Description = styled.p`
  color: #ffffff;
  font-size: 14px;
  line-height: 1.7;
  font-weight: 400;
`;
